var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetworkHealthIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NetworkHealthIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.829,
    height: 20.829,
    viewBox: "0 0 20.829 20.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M9.915,19.829a9.915,9.915,0,1,1,9.915-9.915,9.915,9.915,0,0,1-9.915,9.915Zm0-18.59A8.675,8.675,0,1,0,18.59,9.915,8.675,8.675,0,0,0,9.915,1.239Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M9.718,16.239H6.62A.62.62,0,1,1,6.62,15h3.1a.62.62,0,1,1,0,1.239Z",
    transform: "translate(-2.282 -5.705)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M11.6,13.563a.6.6,0,0,1-.62-.787l1.239-4.338a.642.642,0,0,1,1.239.335l-1.239,4.338A.62.62,0,0,1,11.6,13.563Z",
    transform: "translate(-4.166 -3.029)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M14.855,17.911a.62.62,0,0,1-.62-.533L13,8.7a.626.626,0,1,1,1.239-.174L15.475,17.2a.62.62,0,0,1-.533.706Z",
    transform: "translate(-4.941 -3.039)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M15.6,20.6a.6.6,0,0,1-.62-.787l1.239-4.338a.62.62,0,0,1,1.19.341l-1.239,4.338A.62.62,0,0,1,15.6,20.6Z",
    transform: "translate(-5.688 -5.726)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M21.957,16.239H17.62a.62.62,0,1,1,0-1.239h4.338a.62.62,0,1,1,0,1.239Z",
    transform: "translate(-6.466 -5.705)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkHealthIcon);
export default __webpack_public_path__ + "static/media/NetworkHealthIcon.ff031ac402b8060b5b0a0a3ee2f9cb4e.svg";
export { ForwardRef as ReactComponent };